import Vue from 'vue'
import store from '../store'

Vue.filter('country', value => {
  let country = store.getters.countries.find(item => item.code === value)

  return !country ? value : country.name
})
